/**
 * Utility to extract JWT token from SameSite cookie and store in localStorage
 * This runs as a fallback if the inline script in index.html didn't run
 * The inline script in index.html is preferred as it runs even earlier
 */
export function extractTokenFromCookie(): void {
  // Only run in browser
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  // Try to read token from cookie (set by backend after OAuth2)
  const cookies = document.cookie.split(';');
  let token: string | null = null;
  
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith('oauth2_token=')) {
      token = decodeURIComponent(cookie.substring('oauth2_token='.length));
      break;
    }
  }

  if (token && token.length > 0) {
    // Always prefer the short-lived oauth2 cookie over a stale localStorage JWT
    localStorage.setItem('jwt_token', token);
    
    // Clear the cookie immediately after reading (security best practice)
    document.cookie = 'oauth2_token=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'oauth2_token=; Path=/; Domain=.scryber.ai; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
  
  // Fallback: Also check for code parameter (for backward compatibility during transition)
  if (!token && window.location && window.location.search) {
    const search = window.location.search;
    const codeMatch = search.match(/[?&]code=([^&]*)/);
    
    if (codeMatch) {
      const code = decodeURIComponent(codeMatch[1]);
      // Exchange code for token via API
      fetch('/auth/exchange?code=' + encodeURIComponent(code))
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Token exchange failed');
        })
        .then(data => {
          if (data.token) {
            localStorage.setItem('jwt_token', data.token);
            // Clean up URL
            let newSearch = search.replace(/[?&]code=[^&]*/, '');
            if (newSearch.startsWith('&')) {
              newSearch = '?' + newSearch.substring(1);
            }
            newSearch = newSearch.replace(/&$/, '');
            if (newSearch === '?') {
              newSearch = '';
            }
            const newUrl = window.location.origin + window.location.pathname + (newSearch ? newSearch : '');
            window.history.replaceState({}, document.title, newUrl);
          }
        })
        .catch(error => {
          console.error('Error exchanging code for token:', error);
        });
    }
  }
}

// Run as fallback (inline script in index.html should handle it first)
extractTokenFromCookie();

